import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconHistorySvg } from "./IconHistorySvg.mjs";
const IconHistory = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconHistorySvg, ...svgProps }) });
export {
  IconHistory
};
